export const actions = {
    GET_GENERAL_STATISTICS: 'GET_GENERAL_STATISTICS',
    SET_GENERAL_STATISTICS: 'SET_GENERAL_STATISTICS',

    GET_FILES_ADDED_ACTIVITIES_STATISTICS: 'GET_FILES_ADDED_ACTIVITIES_STATISTICS',
    SET_FILES_ADDED_ACTIVITIES_STATISTICS: 'SET_FILES_ADDED_ACTIVITIES_STATISTICS',

    GET_ACTIVITY_FILES_STATISTICS_BYTERM: 'GET_ACTIVITY_FILES_STATISTICS_BYTERM',
    SET_ACTIVITY_FILES_STATISTICS_BYTERM: 'SET_ACTIVITY_FILES_STATISTICS_BYTERM',

    GET_ACTIVITY_FILES_LIST_BYTERM: 'GET_ACTIVITY_FILES_LIST_BYTERM',
    SET_ACTIVITY_FILES_LIST_BYTERM: 'SET_ACTIVITY_FILES_LIST_BYTERM',

    DELETE_ACTIVITY_FILES: 'DELETE_ACTIVITY_FILES',
    DOWNLOAD_ACTIVITY_FILES: 'DOWNLOAD_ACTIVITY_FILES',
    RESTORE_ACTIVITY_FILES: 'RESTORE_ACTIVITY_FILES',

    GET_COMMUNICATION_FILES_LIST: 'GET_COMMUNICATION_FILES_LIST',
    SET_COMMUNICATION_FILES_LIST: 'SET_COMMUNICATION_FILES_LIST',

    GET_COMMUNICATION_FILES_STATISTICS: 'GET_COMMUNICATION_FILES_STATISTICS',
    SET_COMMUNICATION_FILES_STATISTICS: 'SET_COMMUNICATION_FILES_STATISTICS',

    GET_PERSONEL_FILES_LIST: 'GET_PERSONEL_FILES_LIST',
    SET_PERSONEL_FILES_LIST: 'SET_PERSONEL_FILES_LIST',

    GET_OTHER_FILES_LIST: 'GET_OTHER_FILES_LIST',
    SET_OTHER_FILES_LIST: 'SET_OTHER_FILES_LIST'
};